//(function () {
//    'use strict';

//    angular.module("imApp").factory("postCalcWService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
